import { Component } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';
import { SessionStorageService } from '../services/session-storage.service';
import { ChildService } from '../services/child.service';
import { Globals } from '../services/globals';
import { Router } from '@angular/router';
import { PushService } from '../services/push-service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})

export class MyApp {
  constructor(
    private $childService: ChildService,
    private $local: LocalStorageService,
    private $session: SessionStorageService,
    private $g: Globals,
    private $router: Router,
    private $pushService: PushService) {
    // 탭 인덱스 초기화
    this.$local.setTabIndex(0);

    // FCM Token 가져오기
    if (location.search.split('deviceToken=')) {
      this.$pushService.setKey(location.search.split('deviceToken=')[1]);
    }

    // Checking auto login
    this.checkAutoLogin();
  }

  /**
   * 자녀정보 획득시
   */
  private successRequest(children: Object[]) {
    // 사용자의 자녀 정보 저장
    this.$g.saveChildren(children);
    // 선택된 아동의 정보가 있으면 아동화면 없다면 아동 선택화면
    const page = this.$local.getChildNum() ?
      ['/home'] : ['/choose-children'];
    this.$router.navigate(page);
  }

  /**
   * 아동 정보 요청 후 선택된 아동 여부의 따라 다른 화면
   */
  private requestChildrenInfo() {
    // Local에 저장되어있는 토큰을 session에다가 저장
    this.$session.setAuthorizationToken(
      this.$local.getAuthorizationToken());

    this.$childService.childrenInfo().subscribe(
      children => this.successRequest(children),
      err => console.log('Request children info error', err),
    );
  }

  /**
   * 자동 로그인 확인 후 이동
   */
  private checkAutoLogin() {
    // 자동로그인 여부가 있다면 아동정보 요청 없다면 로그인 화면으로
    this.$local.getAuthorizationToken() ?
      this.requestChildrenInfo() :
      this.$router.navigate(['']);
  }
}
